import { Link } from "react-router-dom";

interface InfoScreenProps {
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
}

export default function InfoScreen({
  title,
  description,
  buttonText,
  buttonLink,
}: InfoScreenProps) {
  return (
    <div className="flex min-h-screen items-center justify-center">
        <div className="w-full max-w-3xl px-6 text-center">
        <div className="p-16 text-white shadow-lg">
            <h2 className="text-4xl mb-8">{title}</h2>
            <p className="text-xl text-gray-300 mb-12">{description}</p>

            <Link
            to={buttonLink}
            className="inline-block bg-primary text-white py-4 px-6 text-xl hover:opacity-75 transition"
            >
            {buttonText}
            </Link>
        </div>
        </div>
    </div>
  );
}
